import { useContext } from 'react'
import { AppContext } from '@state/context'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  EXAM_TYPES,
  PANELS,
  TEXT_SIZES,
} from '@helpers/constants'
import Button from '@components/Button'
import Text from '@components/Text'
import Heading from '@components/Heading'
import ButtonWithLoader from '@components/ButtonWithLoader'
import { useDeleteExam } from '@hooks/mutations/useDeleteExam'
import { useConfirm } from '@hooks/useConfirm'
import { moveItemInArray } from '@helpers/utilities'
import { useUpdateExamSectionOrder } from '@hooks/mutations/useUpdateExamSectionOrder'
import { setCurrentExam } from '@state/actions/appActions'
import { openPanel } from '@state/actions/panelsActions'

// TODO, pass parameters like EditExerciseBlock?
const EditExamBlock = ({ exam }) => {
  const { id, name, type, pivot } = exam
  const { id: pivotId } = pivot

  const [state, dispatch] = useContext(AppContext)
  const {
    app: { currentEditBookObject, userRole, userId, currentSection, editMode },
  } = state

  const { confirm } = useConfirm()

  const typeLabel =
    Object.values(EXAM_TYPES).find(
      (examType) => parseInt(examType.value) === type
    )?.label || 'Label not found'

  // --- Delete

  const { post: postDelete, isPosting: isPostingDelete } = useDeleteExam()

  const deleteExam = async () => {
    const confirmed = await confirm({
      title: name,
      text: 'Är du säker på att du vill radera detta test? Det raderas helt och hållet.',
      confirmText: 'Ja, radera test',
      cancelText: 'Avbryt',
    })

    if (confirmed) {
      const res = await postDelete({
        id: id,
      })

      if (res.success) {
        console.log('Exam deleted')
      }
    }
  }

  // --- Reorder

  const { post: postOrder, isPosting: isPostingOrder } =
    useUpdateExamSectionOrder()

  const moveExam = async (direction) => {
    const allPivotIds = currentSection.exams.map((exam) => exam.pivot.id)
    const currentPosition = allPivotIds.indexOf(pivotId)

    if (
      (direction === 'up' && currentPosition === 0) ||
      (direction === 'down' && currentPosition === allPivotIds.length - 1)
    ) {
      // Cannot move first item up or last item down
    } else {
      const newPosition =
        direction === 'up' ? currentPosition - 1 : currentPosition + 1
      const reorderedPivotIds = moveItemInArray(
        allPivotIds,
        currentPosition,
        newPosition
      )

      if (!isPostingOrder) {
        // post new order
        const res = await postOrder({
          ids: reorderedPivotIds,
        })

        console.log('🚀 ~ moveExam ~ res:', res)
      }
    }
  }

  return (
    <div
      className={
        'flex justify-between items-center bg-lightGrey border border-mediumGrey rounded-sm p-4 my-2'
      }
    >
      <div className={'flex flex-col'}>
        {name ? (
          <Heading headingLevel='h3' size={TEXT_SIZES.XLARGE}>
            {name}
          </Heading>
        ) : (
          <Text size={TEXT_SIZES.XSMALL} bold italic>
            {'Testet har inget namn'}
          </Text>
        )}
        <Text size={TEXT_SIZES.XSMALL}>{typeLabel}</Text>
      </div>

      <div className={'flex flex-col gap-1'}>
        <div className='self-end'>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.LARGE}
            handleClick={() => {
              dispatch(setCurrentExam(exam))
              dispatch(openPanel(PANELS.EDIT_EXAM))
            }}
          >
            Redigera
          </Button>
        </div>
        <div className='self-end'>
          <ButtonWithLoader
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.SMALL}
            isLoading={isPostingDelete}
            disabledText={'Radera'}
            enabledText={'Radera'}
            disabled={isPostingDelete}
            handleClick={() => {
              deleteExam()
            }}
          />
        </div>
        <div className='self-end'>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.SMALL}
            handleClick={() => {
              moveExam('up')
            }}
          >
            &uarr;
          </Button>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.SMALL}
            handleClick={() => {
              moveExam('down')
            }}
          >
            &darr;
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EditExamBlock
